import { ArrowUpRight, PhoneCall } from 'lucide-react';
import workingconstructor from '@/assets/constructorworking.jpg';
import { useNavigate } from 'react-router-dom';

export const Services = () => {
  let navigate = useNavigate();

  const services = [
    {
      icon: '/maintenance.png',
      title: 'Building Maintenance',
      link: '/building-maintenance',
      desc: 'Comprehensive maintenance to ensure your property remains in top condition.',
    },
    {
      icon: '/smallrepair.png',
      title: 'Small Repairs',
      link: '/small-repairs',
      desc: 'Quick and efficient repair solutions for minor damages and fixes.',
    },
    {
      icon: '/refurbish.png',
      title: 'Refurbishment of Flats',
      link: '/flat-refurbishment',
      desc: 'Complete refurbishment services to modernize and upgrade flats.',
    },
    {
      icon: '/painting.png',
      title: 'Painting',
      link: '/painting-services',
      desc: 'Interior and exterior painting with high-quality finishes.',
    },
    {
      icon: '/plumbing.png',
      title: 'Plumbing',
      link: '/plumbing-services',
      desc: 'Professional plumbing services for installations, leaks, and repairs.',
    },
    {
      icon: '/electricalwork.png',
      title: 'Electrical Works',
      link: '/electrical-works',
      desc: 'Safe and reliable electrical installations and maintenance.',
    },
    {
      icon: '/gardening.png',
      title: 'Gardening',
      link: 'gardening-services',
      desc: 'Garden maintenance and beautification for your outdoor spaces.',
    },
    {
      icon: '/roofing.png',
      title: 'Roofing',
      link: '/roofing-services',
      desc: 'Durable and weatherproof roofing installation and repair services.',
    },
    {
      icon: '/cleaning.png',
      title: 'Cleaning',
      link: '/cleaning-services',
      desc: 'Professional cleaning services for residential and commercial properties.',
    },
    {
      icon: '/carpet.png',
      title: 'Carpets and Flooring',
      link: '/flooring-services',
      desc: 'Installation and restoration of all types of flooring and carpets.',
    },
    {
      icon: '/homeextension.png',
      title: 'Home Extensions',
      link: '/home-extensions',
      desc: 'Expand your home with seamless and stylish extensions.',
    },
    {
      icon: '/kitchenfitting.png',
      title: 'Kitchen Fittings',
      link: '/kitchen-fitting-services',
      desc: 'Custom kitchen fitting services with attention to detail.',
    },
    {
      icon: '/bath.png',
      title: 'Bathroom Fittings',
      link: '/bathroom-fittings',
      desc: 'Elegant and functional bathroom installation and design.',
    },
    {
      icon: '/tiling.png',
      title: 'Tiling',
      link: '/tiling-services',
      desc: 'Expert tiling for walls, floors, and decorative finishes.',
    },
    {
      icon: '/groundwork.png',
      title: 'Ground Works',
      link: '/groundwork-services',
      desc: 'Reliable groundwork solutions to prepare for any construction project.',
    },
    {
      icon: '/landscaping.png',
      link: '/landscaping-service',
      title: 'Gardening & Landscaping',
      desc: 'Transform outdoor areas with creative landscaping and garden design.',
    },
  ];

  return (
    <>
      <div className="mt-[9rem] flex w-full justify-center bg-[white] py-[4rem] font-inter">
        <div className="flex w-full max-w-[144rem] flex-row flex-wrap items-stretch justify-center gap-x-[4rem] gap-y-[3rem] px-[2rem]">
          <div className="flex w-full flex-wrap items-start gap-[2rem] md:w-[50%]">
            <div className="w-full">
              <h1 className="hidden text-[3.2rem] font-[700] leading-[4rem] text-[#121212] md:block lg:text-[4rem] lg:leading-[5.5rem]">
                Why Choose Us For Your <br /> Property Maintenance & Repairs
              </h1>
              <h1 className="text-center text-[2.4rem] font-[700] leading-[3.2rem] text-[#121212] md:hidden lg:text-[4rem] lg:leading-[5.5rem]">
                Why Choose Us For Your <br /> Property Maintenance & Repairs
              </h1>

              <p className="mt-[2rem] text-[1.6rem] font-[400] leading-[3.2rem] text-[#666666]">
                At KU Contractors Limited, we take pride in keeping your property in perfect shape —
                from small repairs to complete refurbishments. Our expert team delivers reliable,
                high-quality services including plumbing, electrical works, painting, tiling, and
                much more. We focus on lasting solutions, ensuring comfort, safety, and value for
                every home and business we serve.
              </p>
              <div className="mt-[2rem] flex w-full flex-col gap-y-[1rem]">
                <div className="flex items-center justify-between gap-[1rem]">
                  <div className="flex h-[8rem] w-[8rem] items-center justify-center rounded-full border-[2px] border-[#e24e1f]">
                    <PhoneCall className="mt-[0.3rem] h-auto w-[4rem] text-[#e24e1f]" />
                  </div>
                  <div className="w-[calc(100%-10rem)]">
                    <p className="text-[1.6rem] font-[400] leading-[150%] text-[#121212]">
                      For immediate assistance or emergency repairs,
                      <br /> call us anytime at &nbsp;
                      <strong>07454-926-222</strong>.
                    </p>
                    <div
                      onClick={() => {
                        navigate('/contact-us');
                      }}
                      className="mt-[1rem] flex cursor-pointer justify-start gap-[0.5rem]"
                    >
                      <h1 className="text-[1.6rem] font-[600] leading-[3.2rem] text-[#666666] underline">
                        Contact Us
                      </h1>
                      <ArrowUpRight className="inline-block h-auto w-[2rem] text-[#e24e1f] underline" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full max-w-[40rem] text-center md:w-[50%] md:text-start">
            <img
              alt="placaholder"
              className="h-full w-auto rounded-md object-cover"
              src={workingconstructor}
            />
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div className="flex w-full justify-center bg-[white] py-[4rem] font-inter">
        <div className="flex w-full max-w-[144rem] flex-row flex-wrap items-stretch justify-center gap-x-[1rem] gap-y-[3rem] px-[2rem]">
          <div className="flex w-full flex-wrap items-start gap-[2rem]">
            <div className="flex w-full flex-wrap justify-center">
              <h1 className="w-full max-w-[70rem] text-center text-[2.4rem] font-[700] leading-[3.2rem] text-[#121212] md:text-[3.2rem] md:leading-[4rem] lg:text-[4rem] lg:leading-[5.5rem]">
                Trusted Contractors for Complete Property Solution
              </h1>
              <p className="mt-[1rem] w-full text-center text-[1.6rem] font-[400] text-[#666666]">
                From groundwork to final finishes — we handle construction, repairs, and renovations
                with precision, speed, and professionalism.
              </p>
            </div>

            {/* Service Cards */}
            <div className="mt-[2rem] grid w-full grid-cols-1 gap-[2rem] sm:grid-cols-2 md:mt-[3rem] md:grid-cols-3 lg:mt-[4rem] lg:grid-cols-4">
              {services.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {
                    navigate(item.link);
                  }}
                  className="flex cursor-pointer flex-col items-center justify-start gap-3 rounded-xl border border-[#e5e5e5] bg-[#fafafa] p-6 text-center transition"
                >
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="h-[5rem] w-[5rem] object-contain"
                  />
                  <h3 className="text-[1.8rem] font-semibold text-[#1C253C]">{item.title}</h3>
                  <p className="text-[1.4rem] text-[#555]">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
